<template>
	<div :class="`accordion accordion-${type}`">
		<slot />
	</div>
</template>

<script setup>
import { provide } from 'vue';

const props = defineProps({
	type: {
		type: String,
		default: 'default',
	},

	startOpen: {
		type: Boolean,
		default: true,
	},
});

provide('accordionType', props.type);
provide('accordionStartOpen', props.startOpen);
</script>
